module.exports = __webpack_public_path__ + "static/media/how-it-works.5c51fcf2.svg";